class Banner {
  constructor () {
    this.$el = document.querySelector('.js-banner')

    if (!this.$el)
      return

    this._initialize()
  }
  _initialize () {
    this._index = 0
    this._images = [
      'url(/images/content/01-V.jpg)',
      'url(/images/content/02-O.jpg)',
      'url(/images/content/03-R.jpg)',
      'url(/images/content/04-U.jpg)',
      'url(/images/content/05-M.jpg)',
    ]
    setInterval(this._changeBackground.bind(this), 800)
  }
  _changeBackground() {
    if (this._index > this._images.length) {
      this._index = 0
    }
    this.$el.style.backgroundImage = this._images[this._index++]
  }
}
export default new Banner()
